import '../css/footer.css';
import { Link} from 'react-router-dom';
export default function Footer() {
    return (
        < div className="footer" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="#" target="_blank" rel="noopener noreferrer"><p><i className="fa fa-map-marker-alt"></i>3 No. Basunagar, Shipra Garden Complex,Flat no-3D, Ambalika apartment, Madhyamgram, Kolkata-700129.</p></a>
                            <a href="tel:+91-6290014055"><p><i className="fa fa-phone"></i>+91-6290014055/+91-8697170856</p></a>
                            <a href="mailto:contactnhrf@gmail.com"><p><i className="fa fa-envelope"></i>contactnhrf@gmail.com</p></a>
                            <div className="footer-social">
                                <a className="btn btn-custom" href="https://x.com/contactnhrf?t=LVIjtGTql2iRvctF5RgPpg&s=09"><i className="fab fa-x-twitter"></i></a>
                                <a className="btn btn-custom" href="https://www.facebook.com/share/1Lf7mLeDhR/"><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-custom" href="https://www.instagram.com/contactnhrf?igsh=MXdreTI2c2swZjY4eQ=="><i className="fab fa-instagram"></i></a>
                                <a className="btn btn-custom" href="https://youtube.com/@nationalhumanrightsfederat2355?si=XaPCKPcCWJcO9jDV"><i className="fab fa-youtube"></i></a>
                                {/* <a className="btn btn-custom" href="#"><i className="fab fa-linkedin-in"></i></a> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>Popular Links</h2>
                            <Link to="/about">About Us</Link>
                            <Link to="/contact">Contact Us</Link>
                            {/* <a href="/event">Popular Causes</a>
                            <a href="/event">Upcoming Events</a>
                            <a href="#">Latest Blog</a> */}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>Useful Links</h2>
                            <a href="#">Terms of use</a>
                            <a href="#">Privacy policy</a>
                            <a href="#">Cookies</a>
                            <a href="#">Help</a>
                            <a href="#">FQAs</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-newsletter">
                            <h2>Newsletter</h2>
                            <form name='NewsLetter'>
                                <input name='subscribe' className="form-control" placeholder="Email goes here" autoComplete='email' required/>
                                <button className="btn btn-custom">Submit</button>
                                <h6>Don't worry, we don't spam!</h6>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; <a href="#">THE NHRF NGO</a> | 2025, All Right Reserved.</p>
                    </div>
                   
                </div>
            </div>
        </ div>
    );
}